import { render } from "./Loader.vue?vue&type=template&id=2f18f059&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=2f18f059&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f18f059"]])

export default __exports__